import { SpaceUnavailabilityState } from '../api/types/response/space.response';
import { SpaceState } from '../types/space-state';
import { isStateCurrentlyActive } from './is-state-currently-active';

export const getSpaceCurrentState = (
  spaceUnavailabilityStates: SpaceUnavailabilityState[],
): SpaceState => {
  if (
    spaceUnavailabilityStates.some(
      item =>
        item.state === 'BLOCKED' &&
        isStateCurrentlyActive(item.from, item.until),
    )
  ) {
    return 'BLOCKED';
  }

  if (
    spaceUnavailabilityStates.some(
      item =>
        item.state === 'BOOKED' &&
        isStateCurrentlyActive(item.from, item.until),
    )
  ) {
    return 'BOOKED';
  }

  return 'AVAILABLE';
};
